module.exports = __webpack_public_path__ + "static/img/bundles-tv-second.6c42f496.svg";